import React from 'react'

import { StCredits } from './style.css'

const Credits = () => (
  <StCredits className="font-sans">
    <div className="creditsWrapper">
      <h2 className=" font-actaDisplay">Créditos</h2>

      {/* <p className="font-sans leading-tight">
        Una fiesta universal: El Mundial del 62 es un trabajo conjunto de la{' '}
        <strong>Unidad de Investigación y Datos</strong> y el área de{' '}
        <strong>Narrativas Interactivas de La Tercera</strong>.
      </p>

      <p className="font-sans leading-tight">
        Editor de Audiohistorias:{' '}
        <strong className="block">Francisco Aravena</strong>
      </p>

      <p className="font-sans leading-tight">
        Editor General de Audiencias:{' '}
        <strong className="block">Sebastián Rivas</strong>
      </p>

      <p className="font-sans leading-tight">
        Editora de Narrativas Interactivas:{' '}
        <strong className="block">Tania Opazo</strong>
      </p>

      <p className="font-sans leading-tight">
        Equipo Periodístico: <strong className="block">Leslie Ayala</strong>
        <strong className="block">Sofía Gómez</strong>
        <strong className="block">Esteban González</strong>
        <strong className="block">Francisca Mayorga</strong>
        <strong className="block">Jaime Pinochet</strong>
      </p>

      <p className="font-sans leading-tight">
        Narración, edición y postproducción de audio:{' '}
        <strong className="block">Francisco Aravena</strong>
      </p> */}

      <p className="font-sans leading-tight">
        Desarrollo: <strong className="block">Álex Acuña Viera</strong>
      </p>
    </div>
  </StCredits>
)

export default Credits
